import React, { Component } from 'react';
import rtArrow from '../images/arrow_right_circle.png';
import ltArrow from '../images/arrow_left_circle.png';
import CircleMinus from '../images/minus.png';
import CirclePlus from '../images/add.png';


import '../css/common.css';
import '../css/shopping_list.css'

export default class ShopListRecipeListItem extends Component {

  constructor(props) {
    super(props);

    this.state = { recItem: this.props.recItem }
  }

  directionSet(inc) {
    if (inc)
      return (<img className="sl-rec-move-icon" src={rtArrow} alt="" title="Remove Recipe"/>)
    else {
      return (<img className="sl-rec-move-icon" src={ltArrow} alt="" title="Add Recipe"/>)
    }
  }

  getTitle() {
    var t = this.props.recItem.recipe.Name;
    if (this.props.recItem.count > 1 ) {
      t = t + " x" + this.props.recItem.count;
    }
    return t;
  }

  render ()
  {
    if (this.state.recItem === undefined)
    return "";

    var imageUrl;
    var grpClass;

    if (this.state.recItem.recipe.ImageUrls.length > 0)
    {
      imageUrl = this.state.recItem.recipe.ImageUrls[0];
    }
    else {
      imageUrl = "";
    }

    grpClass = this.props.evenrow === true ? "sl-rec-group-item main-font" : "sl-rec-group-item main-font list-even";
    grpClass = this.props.included === true ? grpClass : grpClass + " pointer";

    return (

        <li id="" 
          onClick={this.props.included === true ? null : () => this.props.onRecipeSelect(this.state.recItem)} 
          title={this.getTitle()} 
          className={grpClass}
        >
          <div className="sl-rec-item-group">
            { !this.props.included ?
              <div id="pointerImageLeft">
                {this.directionSet(this.props.included)}
              </div>
              : null }
            <div className="sl-rec-group-item-img-div">
              <img alt="" className="sl-rec-group-item-img" src={imageUrl} />
            </div>
            <div id="sl-rec-item-group-data">
              <div className="sl-rec-group-item-name">
                {this.props.recItem.recipe.Name}
                { this.props.recItem.count > 1 ? <span className="txtSLRecCnt"><sub>x{this.props.recItem.count}</sub></span> : null}
              </div>
            </div>
            { this.props.included ?
              <div id="pointerImageRight">
                <img 
                  alt=""
                  title="Add 1"
                  className="imgSLRecipItemPlusMinus imgSLRecipItemPlus" 
                  src={CirclePlus} 
                  style={{marginRight: 6}} 
                  onClick={() => this.props.onRecipeAdd(this.state.recItem)}
                /> 
                <img 
                  alt=""
                  title="Remove 1"
                  className="imgSLRecipItemPlusMinus" 
                  src={CircleMinus} 
                  onClick={() => this.props.onRecipeRemove(this.state.recItem)}
                /> 
              </div>
              : null }
          </div>
        </li>
    );
  };
};



// WEBPACK FOOTER //
// ./src/components/shop_list_recipe_item.js